import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=1a8a3830&scoped=true&"
var script = {}
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=1a8a3830&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a3830",
  null
  
)

export default component.exports